// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/users.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import { file_proto_v1_extension_enum } from './extension_enum_pb';
import type {
  AuditUpdater,
  AuditUpdaterJson,
  AuditUpdaterValid,
  ExternalType,
  ExternalTypeJson,
  Pagination,
  PaginationJson,
  SortDirection,
  SortDirectionJson,
  UserRole,
  UserRoleJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/users.proto.
 */
export const file_proto_v1_users: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_buf_validate_validate,
      file_google_protobuf_timestamp,
      file_proto_v1_extension_enum,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceGetResponse
 */
export type UserServiceGetResponse =
  Message<'vmspdb.api.proto.v1.UserServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
     */
    role: UserRole;

    /**
     * @generated from field: string email = 4;
     */
    email: string;

    /**
     * @generated from field: bool active = 5;
     */
    active: boolean;

    /**
     * @generated from field: string external_id = 6;
     */
    externalId: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ExternalType external_type = 7;
     */
    externalType: ExternalType;

    /**
     * @generated from field: string phone_number = 8;
     */
    phoneNumber: string;

    /**
     * @generated from field: map<string, string> attributes = 9;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.UserProvider providers = 10;
     */
    providers: UserProvider[];

    /**
     *  Address address = 10;
     *
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceGetResponse
 */
export type UserServiceGetResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: string email = 4;
   */
  email?: string;

  /**
   * @generated from field: bool active = 5;
   */
  active?: boolean;

  /**
   * @generated from field: string external_id = 6;
   */
  externalId?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ExternalType external_type = 7;
   */
  externalType?: ExternalTypeJson;

  /**
   * @generated from field: string phone_number = 8;
   */
  phoneNumber?: string;

  /**
   * @generated from field: map<string, string> attributes = 9;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.UserProvider providers = 10;
   */
  providers?: UserProviderJson[];

  /**
   *  Address address = 10;
   *
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type UserServiceGetResponseValid = UserServiceGetResponse;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceGetResponse.
 * Use `create(UserServiceGetResponseSchema)` to create a new message.
 */
export const UserServiceGetResponseSchema: GenMessage<
  UserServiceGetResponse,
  {
    jsonType: UserServiceGetResponseJson;
    validType: UserServiceGetResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 0);

/**
 * @generated from message vmspdb.api.proto.v1.UserProvider
 */
export type UserProvider = Message<'vmspdb.api.proto.v1.UserProvider'> & {
  /**
   * @generated from field: string provider_id = 1;
   */
  providerId: string;

  /**
   * @generated from field: string uid = 2;
   */
  uid: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.UserProvider
 */
export type UserProviderJson = {
  /**
   * @generated from field: string provider_id = 1;
   */
  providerId?: string;

  /**
   * @generated from field: string uid = 2;
   */
  uid?: string;
};

export type UserProviderValid = UserProvider;

/**
 * Describes the message vmspdb.api.proto.v1.UserProvider.
 * Use `create(UserProviderSchema)` to create a new message.
 */
export const UserProviderSchema: GenMessage<
  UserProvider,
  { jsonType: UserProviderJson; validType: UserProviderValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 1);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceGetRequest
 */
export type UserServiceGetRequest =
  Message<'vmspdb.api.proto.v1.UserServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceGetRequest
 */
export type UserServiceGetRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceGetRequest
 */
export type UserServiceGetRequestValid =
  Message<'vmspdb.api.proto.v1.UserServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceGetRequest.
 * Use `create(UserServiceGetRequestSchema)` to create a new message.
 */
export const UserServiceGetRequestSchema: GenMessage<
  UserServiceGetRequest,
  { jsonType: UserServiceGetRequestJson; validType: UserServiceGetRequestValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 2);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceCreateRequest
 */
export type UserServiceCreateRequest =
  Message<'vmspdb.api.proto.v1.UserServiceCreateRequest'> & {
    /**
     * @generated from field: string name = 1;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.UserRole role = 2;
     */
    role: UserRole;

    /**
     * @generated from field: string email = 3;
     */
    email: string;

    /**
     * @generated from field: bool active = 4;
     */
    active: boolean;

    /**
     * @generated from field: string phone_number = 5;
     */
    phoneNumber: string;

    /**
     * @generated from field: map<string, string> attributes = 6;
     */
    attributes: { [key: string]: string };

    /**
     *  Address address = 7;
     *
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceCreateRequest
 */
export type UserServiceCreateRequestJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.UserRole role = 2;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: string email = 3;
   */
  email?: string;

  /**
   * @generated from field: bool active = 4;
   */
  active?: boolean;

  /**
   * @generated from field: string phone_number = 5;
   */
  phoneNumber?: string;

  /**
   * @generated from field: map<string, string> attributes = 6;
   */
  attributes?: { [key: string]: string };

  /**
   *  Address address = 7;
   *
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type UserServiceCreateRequestValid = UserServiceCreateRequest;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceCreateRequest.
 * Use `create(UserServiceCreateRequestSchema)` to create a new message.
 */
export const UserServiceCreateRequestSchema: GenMessage<
  UserServiceCreateRequest,
  {
    jsonType: UserServiceCreateRequestJson;
    validType: UserServiceCreateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 3);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceUpdateRequest
 */
export type UserServiceUpdateRequest =
  Message<'vmspdb.api.proto.v1.UserServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
     */
    role: UserRole;

    /**
     * @generated from field: string email = 4;
     */
    email: string;

    /**
     * @generated from field: bool active = 5;
     */
    active: boolean;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: map<string, string> attributes = 7;
     */
    attributes: { [key: string]: string };

    /**
     *  repeated UserProvider providers = 8;
     *  Address address = 8;
     *
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceUpdateRequest
 */
export type UserServiceUpdateRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: string email = 4;
   */
  email?: string;

  /**
   * @generated from field: bool active = 5;
   */
  active?: boolean;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: map<string, string> attributes = 7;
   */
  attributes?: { [key: string]: string };

  /**
   *  repeated UserProvider providers = 8;
   *  Address address = 8;
   *
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceUpdateRequest
 */
export type UserServiceUpdateRequestValid =
  Message<'vmspdb.api.proto.v1.UserServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
     */
    role: UserRole;

    /**
     * @generated from field: string email = 4;
     */
    email: string;

    /**
     * @generated from field: bool active = 5;
     */
    active: boolean;

    /**
     * @generated from field: string phone_number = 6;
     */
    phoneNumber: string;

    /**
     * @generated from field: map<string, string> attributes = 7;
     */
    attributes: { [key: string]: string };

    /**
     *  repeated UserProvider providers = 8;
     *  Address address = 8;
     *
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdaterValid;
  };

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceUpdateRequest.
 * Use `create(UserServiceUpdateRequestSchema)` to create a new message.
 */
export const UserServiceUpdateRequestSchema: GenMessage<
  UserServiceUpdateRequest,
  {
    jsonType: UserServiceUpdateRequestJson;
    validType: UserServiceUpdateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 4);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceCreateResponse
 */
export type UserServiceCreateResponse =
  Message<'vmspdb.api.proto.v1.UserServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
     */
    role: UserRole;

    /**
     * @generated from field: string email = 4;
     */
    email: string;

    /**
     * @generated from field: bool active = 5;
     */
    active: boolean;

    /**
     * @generated from field: string external_id = 6;
     */
    externalId: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ExternalType external_type = 7;
     */
    externalType: ExternalType;

    /**
     * @generated from field: string phone_number = 8;
     */
    phoneNumber: string;

    /**
     * @generated from field: map<string, string> attributes = 9;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.UserProvider providers = 10;
     */
    providers: UserProvider[];

    /**
     *  Address address = 10;
     *
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceCreateResponse
 */
export type UserServiceCreateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: string email = 4;
   */
  email?: string;

  /**
   * @generated from field: bool active = 5;
   */
  active?: boolean;

  /**
   * @generated from field: string external_id = 6;
   */
  externalId?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ExternalType external_type = 7;
   */
  externalType?: ExternalTypeJson;

  /**
   * @generated from field: string phone_number = 8;
   */
  phoneNumber?: string;

  /**
   * @generated from field: map<string, string> attributes = 9;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.UserProvider providers = 10;
   */
  providers?: UserProviderJson[];

  /**
   *  Address address = 10;
   *
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type UserServiceCreateResponseValid = UserServiceCreateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceCreateResponse.
 * Use `create(UserServiceCreateResponseSchema)` to create a new message.
 */
export const UserServiceCreateResponseSchema: GenMessage<
  UserServiceCreateResponse,
  {
    jsonType: UserServiceCreateResponseJson;
    validType: UserServiceCreateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 5);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceUpdateResponse
 */
export type UserServiceUpdateResponse =
  Message<'vmspdb.api.proto.v1.UserServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
     */
    role: UserRole;

    /**
     * @generated from field: string email = 4;
     */
    email: string;

    /**
     * @generated from field: bool active = 5;
     */
    active: boolean;

    /**
     * @generated from field: string external_id = 6;
     */
    externalId: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ExternalType external_type = 7;
     */
    externalType: ExternalType;

    /**
     * @generated from field: string phone_number = 8;
     */
    phoneNumber: string;

    /**
     * @generated from field: map<string, string> attributes = 9;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.UserProvider providers = 10;
     */
    providers: UserProvider[];

    /**
     *  Address address = 10;
     *
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceUpdateResponse
 */
export type UserServiceUpdateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.UserRole role = 3;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: string email = 4;
   */
  email?: string;

  /**
   * @generated from field: bool active = 5;
   */
  active?: boolean;

  /**
   * @generated from field: string external_id = 6;
   */
  externalId?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ExternalType external_type = 7;
   */
  externalType?: ExternalTypeJson;

  /**
   * @generated from field: string phone_number = 8;
   */
  phoneNumber?: string;

  /**
   * @generated from field: map<string, string> attributes = 9;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.UserProvider providers = 10;
   */
  providers?: UserProviderJson[];

  /**
   *  Address address = 10;
   *
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type UserServiceUpdateResponseValid = UserServiceUpdateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceUpdateResponse.
 * Use `create(UserServiceUpdateResponseSchema)` to create a new message.
 */
export const UserServiceUpdateResponseSchema: GenMessage<
  UserServiceUpdateResponse,
  {
    jsonType: UserServiceUpdateResponseJson;
    validType: UserServiceUpdateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 6);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceListRequest
 */
export type UserServiceListRequest =
  Message<'vmspdb.api.proto.v1.UserServiceListRequest'> & {
    /**
     * @generated from field: string filter = 1;
     */
    filter: string;

    /**
     * @generated from field: uint32 page_index = 2;
     */
    pageIndex: number;

    /**
     * @generated from field: uint32 page_size = 3;
     */
    pageSize: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
     */
    sortDirection: SortDirection;

    /**
     * @generated from field: string sort_field = 5 [deprecated = true];
     * @deprecated
     */
    sortField: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.UserSort sort = 7;
     */
    sort: UserSort;

    /**
     * include all users
     *
     * @generated from field: bool all = 6;
     */
    all: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceListRequest
 */
export type UserServiceListRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex?: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
   */
  sortDirection?: SortDirectionJson;

  /**
   * @generated from field: string sort_field = 5 [deprecated = true];
   * @deprecated
   */
  sortField?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.UserSort sort = 7;
   */
  sort?: UserSortJson;

  /**
   * include all users
   *
   * @generated from field: bool all = 6;
   */
  all?: boolean;
};

export type UserServiceListRequestValid = UserServiceListRequest;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceListRequest.
 * Use `create(UserServiceListRequestSchema)` to create a new message.
 */
export const UserServiceListRequestSchema: GenMessage<
  UserServiceListRequest,
  {
    jsonType: UserServiceListRequestJson;
    validType: UserServiceListRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 7);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceListResponse
 */
export type UserServiceListResponse =
  Message<'vmspdb.api.proto.v1.UserServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.UserServiceCreateResponse items = 1;
     */
    items: UserServiceCreateResponse[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceListResponse
 */
export type UserServiceListResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.UserServiceCreateResponse items = 1;
   */
  items?: UserServiceCreateResponseJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
   */
  pagination?: PaginationJson;

  /**
   * @generated from field: bool degraded = 3;
   */
  degraded?: boolean;
};

export type UserServiceListResponseValid = UserServiceListResponse;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceListResponse.
 * Use `create(UserServiceListResponseSchema)` to create a new message.
 */
export const UserServiceListResponseSchema: GenMessage<
  UserServiceListResponse,
  {
    jsonType: UserServiceListResponseJson;
    validType: UserServiceListResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 8);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceResetPasswordRequest
 */
export type UserServiceResetPasswordRequest =
  Message<'vmspdb.api.proto.v1.UserServiceResetPasswordRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceResetPasswordRequest
 */
export type UserServiceResetPasswordRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceResetPasswordRequest
 */
export type UserServiceResetPasswordRequestValid =
  Message<'vmspdb.api.proto.v1.UserServiceResetPasswordRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceResetPasswordRequest.
 * Use `create(UserServiceResetPasswordRequestSchema)` to create a new message.
 */
export const UserServiceResetPasswordRequestSchema: GenMessage<
  UserServiceResetPasswordRequest,
  {
    jsonType: UserServiceResetPasswordRequestJson;
    validType: UserServiceResetPasswordRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 9);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceResetPasswordResponse
 */
export type UserServiceResetPasswordResponse =
  Message<'vmspdb.api.proto.v1.UserServiceResetPasswordResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceResetPasswordResponse
 */
export type UserServiceResetPasswordResponseJson = {};

export type UserServiceResetPasswordResponseValid =
  UserServiceResetPasswordResponse;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceResetPasswordResponse.
 * Use `create(UserServiceResetPasswordResponseSchema)` to create a new message.
 */
export const UserServiceResetPasswordResponseSchema: GenMessage<
  UserServiceResetPasswordResponse,
  {
    jsonType: UserServiceResetPasswordResponseJson;
    validType: UserServiceResetPasswordResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 10);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceVerifyEmailRequest
 */
export type UserServiceVerifyEmailRequest =
  Message<'vmspdb.api.proto.v1.UserServiceVerifyEmailRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceVerifyEmailRequest
 */
export type UserServiceVerifyEmailRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceVerifyEmailRequest
 */
export type UserServiceVerifyEmailRequestValid =
  Message<'vmspdb.api.proto.v1.UserServiceVerifyEmailRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceVerifyEmailRequest.
 * Use `create(UserServiceVerifyEmailRequestSchema)` to create a new message.
 */
export const UserServiceVerifyEmailRequestSchema: GenMessage<
  UserServiceVerifyEmailRequest,
  {
    jsonType: UserServiceVerifyEmailRequestJson;
    validType: UserServiceVerifyEmailRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 11);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceVerifyEmailResponse
 */
export type UserServiceVerifyEmailResponse =
  Message<'vmspdb.api.proto.v1.UserServiceVerifyEmailResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceVerifyEmailResponse
 */
export type UserServiceVerifyEmailResponseJson = {};

export type UserServiceVerifyEmailResponseValid =
  UserServiceVerifyEmailResponse;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceVerifyEmailResponse.
 * Use `create(UserServiceVerifyEmailResponseSchema)` to create a new message.
 */
export const UserServiceVerifyEmailResponseSchema: GenMessage<
  UserServiceVerifyEmailResponse,
  {
    jsonType: UserServiceVerifyEmailResponseJson;
    validType: UserServiceVerifyEmailResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 12);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceDeleteRequest
 */
export type UserServiceDeleteRequest =
  Message<'vmspdb.api.proto.v1.UserServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceDeleteRequest
 */
export type UserServiceDeleteRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceDeleteRequest
 */
export type UserServiceDeleteRequestValid =
  Message<'vmspdb.api.proto.v1.UserServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceDeleteRequest.
 * Use `create(UserServiceDeleteRequestSchema)` to create a new message.
 */
export const UserServiceDeleteRequestSchema: GenMessage<
  UserServiceDeleteRequest,
  {
    jsonType: UserServiceDeleteRequestJson;
    validType: UserServiceDeleteRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 13);

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceDeleteResponse
 */
export type UserServiceDeleteResponse =
  Message<'vmspdb.api.proto.v1.UserServiceDeleteResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.UserServiceDeleteResponse
 */
export type UserServiceDeleteResponseJson = {};

export type UserServiceDeleteResponseValid = UserServiceDeleteResponse;

/**
 * Describes the message vmspdb.api.proto.v1.UserServiceDeleteResponse.
 * Use `create(UserServiceDeleteResponseSchema)` to create a new message.
 */
export const UserServiceDeleteResponseSchema: GenMessage<
  UserServiceDeleteResponse,
  {
    jsonType: UserServiceDeleteResponseJson;
    validType: UserServiceDeleteResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_users, 14);

/**
 * @generated from enum vmspdb.api.proto.v1.UserSort
 */
export enum UserSort {
  /**
   * @generated from enum value: USER_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_SORT_NAME = 1;
   */
  NAME = 1,

  /**
   * @generated from enum value: USER_SORT_EMAIL = 2;
   */
  EMAIL = 2,

  /**
   * @generated from enum value: USER_SORT_POSITION = 3;
   */
  POSITION = 3,

  /**
   * @generated from enum value: USER_SORT_ROLE = 4;
   */
  ROLE = 4,
}

/**
 * @generated from enum vmspdb.api.proto.v1.UserSort
 */
export type UserSortJson =
  | 'USER_SORT_UNSPECIFIED'
  | 'USER_SORT_NAME'
  | 'USER_SORT_EMAIL'
  | 'USER_SORT_POSITION'
  | 'USER_SORT_ROLE';

/**
 * Describes the enum vmspdb.api.proto.v1.UserSort.
 */
export const UserSortSchema: GenEnum<UserSort, UserSortJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_users, 0);

/**
 * @generated from service vmspdb.api.proto.v1.UserService
 */
export const UserService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.UserService.Create
   */
  create: {
    methodKind: 'unary';
    input: typeof UserServiceCreateRequestSchema;
    output: typeof UserServiceCreateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.UserService.Update
   */
  update: {
    methodKind: 'unary';
    input: typeof UserServiceUpdateRequestSchema;
    output: typeof UserServiceUpdateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.UserService.ResetPassword
   */
  resetPassword: {
    methodKind: 'unary';
    input: typeof UserServiceResetPasswordRequestSchema;
    output: typeof UserServiceResetPasswordResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.UserService.VerifyEmail
   */
  verifyEmail: {
    methodKind: 'unary';
    input: typeof UserServiceVerifyEmailRequestSchema;
    output: typeof UserServiceVerifyEmailResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.UserService.Get
   */
  get: {
    methodKind: 'unary';
    input: typeof UserServiceGetRequestSchema;
    output: typeof UserServiceGetResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.UserService.List
   */
  list: {
    methodKind: 'unary';
    input: typeof UserServiceListRequestSchema;
    output: typeof UserServiceListResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.UserService.Delete
   */
  delete: {
    methodKind: 'unary';
    input: typeof UserServiceDeleteRequestSchema;
    output: typeof UserServiceDeleteResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_users, 0);
